import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-locked-project-icon',
    templateUrl: './locked-project-icon.component.html',
    styleUrl: './locked-project-icon.component.scss',
    standalone: false
})
export class LockedProjectIconComponent {

}
